import { getAmplitudeInstance } from '../amplitudeHelpers';
import CarouselDisplayTrigger from '../enums/CarouselDisplayTrigger';
import InstallPromptLocation from '../enums/InstallPromptLocation';
import InstallPromptSource from '../enums/InstallPromptSource';
import InstallPromptTrigger from '../enums/InstallPromptTrigger';
import InstallPromptType from '../enums/InstallPromptType';

type logInstallPromptClickedParams = {
  install_prompt_location: InstallPromptLocation;
  install_prompt_source?: InstallPromptSource;
  install_prompt_trigger?: InstallPromptTrigger;
  install_prompt_type: InstallPromptType;
  signup_modal_trigger?: CarouselDisplayTrigger;
};

/**
 * User clicks on a prompt during a web session to install the app
 * @param params - Attributes to log with the amplitude event
 * @param params.install_prompt_location - Type of page the user was on when the prompt was triggered: home, park, trail, signup wall, etc.
 * @param params.install_prompt_source - Whether the prompt was served by Branch or natively built
 * @param params.install_prompt_trigger - Entry point for where the user entered the install prompt (google-one-tap, trail-map, etc.)
 * @param params.install_prompt_type - Type of install prompt displayed to the user, depending on their journey: banner (home page, park page, trail page), interstitial (any signup wall), module (homepage module)
 * @param params.signup_modal_trigger - If a signup modal triggers the install prompt, what triggered the signup modal.
 */
const logInstallPromptClicked = (
  {
    install_prompt_location,
    install_prompt_source,
    install_prompt_trigger,
    install_prompt_type,
    signup_modal_trigger
  }: logInstallPromptClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'install prompt clicked',
    {
      'install prompt location': install_prompt_location,
      'install prompt source': install_prompt_source,
      'install prompt trigger': install_prompt_trigger,
      'install prompt type': install_prompt_type,
      'signup modal trigger': signup_modal_trigger
    },
    callback
  );
};

export default logInstallPromptClicked;
